module.exports = __webpack_public_path__ + "img/logo-dark.14db310d.svg";